import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FaSearch, FaUserCircle } from 'react-icons/fa';
import { useDispatch, useSelector } from "react-redux";
import { getTopics, postAnswerComment, postQuestionComment } from "../../../store/topicSlice";

const QAA = ({ item }) => {
    const { t } = useTranslation();
    const [search, setSearch] = useState('');
    const [active, setActive] = useState("");
    const [question, setQuestion] = useState("");
    const [input, setInput] = useState("")
    const [questionInput, setQuestionInput] = useState('');
    const dispatch = useDispatch();

    console.log(item.questions);
    

    const timeAgo = (dateString) => {
        const date = new Date(dateString);
        const now = new Date();
        const diffInSeconds = Math.floor((now - date) / 1000);
        
        const intervals = [
            { label: 'year', seconds: 31536000 },
            { label: 'month', seconds: 2592000 },
            { label: 'week', seconds: 604800 },
            { label: 'day', seconds: 86400 },
            { label: 'hour', seconds: 3600 },
            { label: 'minute', seconds: 60 },
            { label: 'second', seconds: 1 },
        ];

        for (const interval of intervals) {
            const count = Math.floor(diffInSeconds / interval.seconds);
            if (count >= 1) {
                const unitKey = count === 1 ? interval.label : `${interval.label}_plural`;
                const unit = t(`time.${unitKey}`);
                return `${count} ${unit} ${t('time.ago_suffix')}`;
            }
        }

        return t('time.just_now');
    };
    
    const detailQuestion = (value) => {
        setActive(value);
    }

    const postComment = async () => {
        if (input.length) {
            try {
                const response = await dispatch(postAnswerComment({ question: active.id, content: input })).unwrap();
                setActive({ ...active, answers: [response, ...active.answers] })
            } catch (error) {
                console.error(t('errors.comment_failed'), error);
            }
        }
    };

    const postQuestion = async () => {
        if (questionInput.length) {
            try {
                const response = await dispatch(postQuestionComment({ lecture: item.id, content: questionInput })).unwrap();
                dispatch(getTopics())
                setQuestion(false)
            } catch (error) {
                console.error(t('errors.question_failed'), error);
            }
        }
    };

    return (
        <div className="p-5">
            {active ? (
                <>
                    <button className='bg-[#1E1E1E1A] p-[10px_14px] rounded-xl' onClick={() => setActive('')}>
                        {t('buttons.back_to_questions')}
                    </button>
                    <p className='mt-[12px]'>{t('labels.question')}</p>
                    <div className="mt-[10px] flex justify-between items-end p-4 bg-[#F2F2F3] shadow-md rounded-xl mb-3">
                        <div className="flex gap-4 items-start" style={{
                            minWidth: "50px"
                        }}>
                            <div className="flex justify-center">
                                <img 
                                    src={`${active.user.photo ? active.user.photo : "/images/Profile/beg.png"}`} 
                                    alt={active.user.first_name} 
                                    className='h-[50px] w-[50px] rounded-[50%] object-cover'
                                />
                            </div>
                            <div className="grid gap-4">
                                <div>
                                    <p className="text-[20px] font-semibold text-[#0A1F44]">
                                        {active.title}
                                    </p>
                                    <p className="text-[#1E1E1E] text-[17px]">{active.content}</p>
                                </div>
                                <div className='flex items-center gap-[5px]'>
                                    <p className="text-sm text-gray-500">
                                        {timeAgo(active.created_at)}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='mt-[12px]'>
                        {t('labels.your_answer')}
                        <input 
                            type="text" 
                            onChange={(e) => setInput(e.target.value)} 
                            className='w-full bg-[#F2F2F3] p-[5px_20px] rounded-xl'
                            placeholder={t('placeholders.answer')}
                        />
                        <div className='text-right'>
                            <button 
                                onClick={() => postComment(active)} 
                                className='bg-[#8C1C1C] text-white py-[12px] w-[300px] rounded-2xl mt-[20px]'
                            >
                                {t('buttons.reply')}
                            </button>
                        </div>
                    </div>
                    <div className="mt-4">
                        {active.answers?.length ? (
                            [...active.answers].sort((a, b) => b.id - a.id)?.map(q => (
                                <div key={q.id} className="flex justify-between items-end p-4 bg-[#F2F2F3] shadow-md rounded-xl mb-3">
                                    <div className="flex gap-4 items-start" style={{
                                            minWidth: "50px"
                                        }}>
                                        <div className="flex justify-center w-[50px]">
                                            <img 
                                                src={`${q.user.photo ? q.user.photo : "/images/Profile/beg.png"}`} 
                                                alt={q.user.first_name}
                                                className='h-[50px] w-[50px] rounded-[50%] object-cover'
                                                style={{
                                                    minWidth: "50px"
                                                }}
                                            />
                                        </div>
                                        <div className="grid gap-4">
                                            <div>
                                                <p className="text-[20px] font-semibold text-[#0A1F44]">
                                                    {q.title}
                                                </p>
                                                <p className="text-[#1E1E1E] text-[17px]">{q.content}</p>
                                            </div>
                                            <div className='flex items-center gap-[5px]'>
                                                <p className="text-sm text-gray-500">
                                                    {timeAgo(q.created_at)}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <p className="text-center text-gray-500">{t('messages.no_answers')}</p>
                        )}
                    </div>
                </>
            ) : question ? (
                <>
                    <button className='bg-[#1E1E1E1A] p-[10px_14px] rounded-xl flex gap-1 items-center cursor-pointer' onClick={() => setQuestion(false)}>
                        <span>
                            <svg width="21" height="14" viewBox="0 0 21 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M19.5858 7H1.58579M6.58579 1L1.29289 6.29289C0.902369 6.68342 0.902369 7.31658 1.29289 7.70711L6.58579 13"
                                    stroke="#1E1E1E" strokeWidth="1.5" strokeLinecap="round"/>
                            </svg>
                        </span>
                        {t('buttons.back_to_questions')}
                    </button>
                    <div className='mt-[12px]'>
                        {t('labels.your_answer')}
                        <input 
                            type="text" 
                            onChange={(e) => setQuestionInput(e.target.value)} 
                            className='w-full bg-[#F2F2F3] p-[5px_20px] rounded-xl'
                            placeholder={t('placeholders.question')}
                        />
                        <div className='text-right'>
                            <button 
                                onClick={() => postQuestion(active)} 
                                className='bg-[#8C1C1C] text-white py-[12px] w-[300px] rounded-2xl mt-[20px]'
                            >
                                {t('buttons.reply')}
                            </button>
                        </div>
                    </div>
                </>
            ) : (
                <>
                    <div className="flex items-center border rounded-lg p-2 w-full max-w-md bg-gray-100">
                        <FaSearch className="text-gray-500 mr-2" />
                        <input
                            type="text"
                            placeholder={t('placeholders.search')}
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            className="w-full bg-transparent outline-none"
                        />
                    </div>
                    <div className="flex justify-between my-4">
                        <div className='flex gap-4'>
                            <select className="p-2 border rounded-lg" onChange={(e) => ''}>
                                <option value="all">{t('filters.all')}</option>
                                <option value="important">{t('filters.important')}</option>
                                <option value="answered">{t('filters.answered')}</option>
                                <option value="unanswered">{t('filters.unanswered')}</option>
                            </select>

                            <select className="p-2 border rounded-lg" onChange={(e) => ''}>
                                <option value="newest">{t('sort.newest')}</option>
                                <option value="oldest">{t('sort.oldest')}</option>
                                <option value="alphabetical">{t('sort.alphabetical')}</option>
                            </select>
                        </div>
                        <button 
                            onClick={() => setQuestion(true)} 
                            className='bg-[#8C1C1C] text-white py-[12px] w-[300px] rounded-2xl'
                        >
                            {t('buttons.ask_question')}
                        </button>
                    </div>
                    <div className="mt-4">
                        {item.questions?.length ? (
                            [...item.questions].sort((a, b) => b.id - a.id).map(q => (
                                <div key={q.id} className="flex justify-between items-end p-4 bg-[#F2F2F3] shadow-md rounded-xl mb-3">
                                    <div className="flex gap-4 items-start">
                                        <div className="flex justify-center" style={{
                                            minWidth: "50px"
                                        }}>
                                            <img 
                                                src={`${q.user.photo ? q.user.photo : "/images/Profile/beg.png"}`} 
                                                alt={q.user.first_name}
                                                className='h-[50px] w-[50px] rounded-[50%] object-cover'
                                            />
                                        </div>
                                        <div className="grid gap-4">
                                            <div>
                                                <p className="text-[20px] font-semibold text-[#0A1F44]">
                                                    {q.title}
                                                </p>
                                                <p className="text-[#1E1E1E] text-[17px]">{q.content}</p>
                                            </div>
                                            <div className='flex items-center gap-[5px]'>
                                                <p className="text-sm text-gray-500">
                                                    {timeAgo(q.created_at)}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='flex items-center gap-[20px]'>
                                        <div className='flex items-end gap-[5px]'>
                                            {q.answers.length > 0 && (
                                                <>
                                                    <p>{q.answers.length}</p>
                                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <g opacity="0.7">
                                                            <path d="M5 3H13.5C14.2001 3 14.5501 3 14.8175 3.13891C15.0527 3.2611 15.2439 3.45608 15.3638 3.69589C15.5 3.96853 15.5 4.32542 15.5 5.03922V9.88235C15.5 10.5961 15.5 10.953 15.3638 11.2257C15.2439 11.4655 15.0527 11.6605 14.8175 11.7827C14.5501 11.9216 14.2001 11.9216 13.5 11.9216H8.90275C8.56791 11.9216 8.40049 11.9216 8.23988 11.9534C8.09738 11.9817 7.95918 12.0285 7.8288 12.0926C7.68187 12.1648 7.54887 12.2666 7.28289 12.4699L6.01017 13.4432C5.80133 13.6029 5.5 13.454 5.5 13.1911V12.4216C5.5 12.1454 5.27614 11.9216 5 11.9216C4.29993 11.9216 3.9499 11.9216 3.68251 11.7827C3.44731 11.6605 3.25608 11.4655 3.13624 11.2257C3 10.953 3 10.5961 3 9.88235V5.03922C3 4.32542 3 3.96853 3.13624 3.69589C3.25608 3.45608 3.44731 3.2611 3.68251 3.13891C3.9499 3 4.29993 3 5 3Z" fill="#0A1F44"/>
                                                            <path d="M18 5.69616V12.3824C18 13.0961 18 13.453 17.8638 13.7257C17.7439 13.9655 17.5527 14.1605 17.3175 14.2827C17.0501 14.4216 16.7001 14.4216 16 14.4216C15.7239 14.4216 15.5 14.6454 15.5 14.9216V15.6911C15.5 15.954 15.1987 16.1029 14.9898 15.9432L13.7171 14.9699C13.4511 14.7666 13.3181 14.6648 13.1712 14.5926C13.0408 14.5285 12.9026 14.4817 12.7601 14.4534C12.5995 14.4216 12.4321 14.4216 12.0972 14.4216H8.83331M5 3H13.5C14.2001 3 14.5501 3 14.8175 3.13891C15.0527 3.2611 15.2439 3.45608 15.3638 3.69589C15.5 3.96853 15.5 4.32542 15.5 5.03922V9.88235C15.5 10.5961 15.5 10.953 15.3638 11.2257C15.2439 11.4655 15.0527 11.6605 14.8175 11.7827C14.5501 11.9216 14.2001 11.9216 13.5 11.9216H8.90275C8.56791 11.9216 8.40049 11.9216 8.23988 11.9534C8.09738 11.9817 7.95918 12.0285 7.8288 12.0926C7.68187 12.1648 7.54887 12.2666 7.28289 12.4699L6.01017 13.4432C5.80133 13.6029 5.5 13.454 5.5 13.1911V12.4216C5.5 12.1454 5.27614 11.9216 5 11.9216C4.29993 11.9216 3.9499 11.9216 3.68251 11.7827C3.44731 11.6605 3.25608 11.4655 3.13624 11.2257C3 10.953 3 10.5961 3 9.88235V5.03922C3 4.32542 3 3.96853 3.13624 3.69589C3.25608 3.45608 3.44731 3.2611 3.68251 3.13891C3.9499 3 4.29993 3 5 3Z" stroke="#0A1F44" stroke-width="1.5" stroke-linecap="round"/>
                                                        </g>
                                                    </svg>
                                                </>
                                            )}
                                        </div>
                                        <button onClick={() => detailQuestion(q)}>
                                            {t('buttons.reply')}
                                        </button>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <p className="text-center text-gray-500">{t('messages.no_questions')}</p>
                        )}
                    </div>
                </>
            )}
        </div>
    );
};

export default QAA;